export default __webpack_public_path__ + "static/home-hero-888ea406ea02f28abcd7563b9e634a71.mp4";